
import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';

interface Candidature {
  cvUrl: string | undefined;
  id: number;
  nom: string;
  email: string;
  message: string;
  cvPath?: string;
}

const API_URL = 'http://localhost:8081/api/candidature/liste';

const AdminCandidatures = () => {
  const [candidatures, setCandidatures] = useState<Candidature[]>([]);
  const [error, setError] = useState('');
  const [openId, setOpenId] = useState<number | null>(null);

  useEffect(() => {
    fetch(API_URL)
      .then(res => {
        if (!res.ok) throw new Error('Erreur lors du chargement des candidatures');
        return res.json();
      })
      .then((data: Candidature[]) => {
        const withUrls = data.map(c => ({
          ...c,
          cvUrl: c.cvPath ? `http://localhost:8081/api/candidature/cv?id=${c.id}` : undefined
        }));
        setCandidatures(withUrls);
      })
      .catch(() => setError("Erreur lors du chargement des candidatures"));
  }, []);

  // Fonction pour télécharger le fichier
  function handleDownload(url: string, filename: string): void {
    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error(`Erreur HTTP ${response.status} - ${response.statusText}`);
        return response.blob();
      })
      .then(blob => {
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(downloadUrl);
      })
      .catch((error) => {
        console.error("Erreur lors du téléchargement du fichier:", error);
        alert(`Erreur lors du téléchargement du fichier : ${error.message}`);
      });
  }
  

  return (
    <>
      <Navbar />
      <div className="w-full flex justify-center py-6 mb-8">
        <div className="flex gap-6 bg-white/80 rounded-3xl shadow-2xl px-8 py-2 border-2 border-red-200 backdrop-blur-md">
          <a href="/admin" className="px-5 py-2 rounded-full font-semibold transition text-red-700 hover:bg-red-100 hover:text-red-900">Retour</a>
          <a href="/admin/candidatures" className="px-5 py-2 rounded-full font-semibold transition text-green-700 hover:bg-green-100 hover:text-green-900 bg-green-100 ring-2 ring-green-300">Candidature</a>
        </div>
      </div>
      <div className="min-h-screen flex flex-col items-center bg-gradient-to-br from-red-100 via-white to-green-100 py-16">
        <div className="bg-white/90 p-10 rounded-3xl shadow-2xl border-2 border-green-200 w-full max-w-3xl mb-8 backdrop-blur-md">
          <h2 className="text-3xl font-extrabold text-green-700 mb-6 text-center tracking-tight drop-shadow">Candidatures spontanées reçues</h2>
          {error && <p className="text-red-500 text-center mb-4">{error}</p>}
          {candidatures.length === 0 && !error && (
            <p className="text-gray-500 text-center">Aucune candidature reçue pour le moment.</p>
          )}
          {candidatures.length > 0 && (
            <div className="flex flex-col gap-6">
              {candidatures.map((c) => (
                <section key={c.id} className="bg-white/90 border-2 border-green-100 rounded-2xl shadow p-6 flex flex-col gap-2">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                    <div>
                      <div className="font-bold text-green-700 text-lg">{c.nom}</div>
                      <div className="text-gray-700">{c.email}</div>
                    </div>
                    <button
                      onClick={() => setOpenId(openId === c.id ? null : c.id)}
                      className="px-4 py-2 rounded-lg bg-gradient-to-r from-green-400 to-red-300 text-white font-semibold shadow hover:scale-105 transition"
                    >
                      {openId === c.id ? 'Masquer détails' : 'Voir détails'}
                    </button>
                  </div>
                  {openId === c.id && (
                    <div className="mt-4 border-t border-green-100 pt-4">
                      <div className="mb-2">
                        <span className="font-semibold text-green-700">Message :</span>
                        <div className="text-gray-800 whitespace-pre-line mt-1">{c.message}</div>
                      </div>
                      <div>
                        <span className="font-semibold text-green-700">CV :</span>{' '}
                        {c.cvUrl ? (
                          <button
                            onClick={() => handleDownload(c.cvUrl || '', `cv_${c.id}.pdf`)}
                            className="text-blue-600 underline hover:text-blue-800"
                          >
                            Télécharger
                          </button>
                        ) : (
                          <span className="text-gray-400 ml-2">Aucun</span>
                        )}
                      </div>
                    </div>
                  )}
                </section>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AdminCandidatures;












































































// import React, { useEffect, useState } from "react";
// import axios from "axios";

// function CandidaturesList() {
//   const [candidatures, setCandidatures] = useState([]);

//   useEffect(() => {
//     axios.get("http://localhost:8081/api/candidature/liste")
//       .then(response => {
//         setCandidatures(response.data);
//       })
//       .catch(error => {
//         console.error("Erreur lors de la récupération des candidatures :", error);
//       });
//   }, []);

//   return (
//     <div>
//       <h2>Liste des Candidatures</h2>
//       <ul>
//         {candidatures.map(c => (
//           <li key={c.id}>
//             <strong>{c.nom}</strong> - {c.email} <br />
//             Message: {c.message} <br />
//             CV: {c.cv}
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// }

// export default CandidaturesList;
